<div class="dropdown">
  <div class="dropdown-header flex items-center justify-between">
    <div>
      <div class="dropdown-heading">Notificaciones</div>
      <div *ngIf="getNotReadeds() > 0" class="dropdown-subheading">Tienes {{ getNotReadeds() }} nuevas notificaciones.</div>
      <div *ngIf="getNotReadeds() == 0" class="dropdown-subheading">No tienes nuevas notificaciones.</div>
    </div>

    <!-- <button [matMenuTriggerFor]="settingsMenu" mat-icon-button type="button">
      <mat-icon class="notifications-header-icon" svgIcon="mat:settings"></mat-icon>
    </button> -->
  </div>

  <div class="dropdown-content">
    <a *ngFor="let notification of notifications; trackBy: trackById"
       [class.read]="notification.readed"
       [routerLink]="[]"
       (click)="viewNotication(notification)"
       class="notification flex items-center"
       matRipple>

      <div class="icon-wrapper">

        <mat-icon [ngClass]="notification.colorClass"
                [svgIcon]="notification.icon"
                class="notification-icon"></mat-icon>

        <a (click)="deleteNotification($event, notification)" mat-icon-button
          class="w-8 h-8 text-red-500 bg-red-light leading-none cursor-pointer flex items-center justify-center">
          <mat-icon class="icon-sm" svgIcon="mat:delete"></mat-icon>
        </a>

      </div>

      <div class="flex-auto content-text">
        <h2 class="notification-label">{{ notification.title }}</h2>
        <p class="notification-label">
          <small>{{ notification.message }}</small>
        </p>
        <div class="notification-description">{{ notification.datetime }}</div>
      </div>
      <mat-icon *ngIf="!notification.readed" class="text-red-500 bg-red-500 text-sm ml-4" svgIcon="mat:brightness_1"></mat-icon>
    </a>
  </div>

  <!-- <div class="dropdown-footer flex items-center justify-center">
    <button color="primary" (click)="setAllReaded()" mat-button type="button">Marcar a todos como leídos </button>
  </div> -->
</div>

<!-- <mat-menu #settingsMenu="matMenu" xPosition="before" yPosition="below">
  <button (click)="setAllReaded()" mat-menu-item>
    <mat-icon svgIcon="mat:clear_all"></mat-icon>
    <span>Marcar a todos como leídos </span>
  </button>

  <button mat-menu-item>
    <mat-icon svgIcon="mat:notifications_off"></mat-icon>
    <span>Disable Notifications</span>
  </button>
</mat-menu> -->
